import { render, staticRenderFns } from "./CoursewareStructuralElementDialogExport.vue?vue&type=template&id=73a6f5be&"
import script from "./CoursewareStructuralElementDialogExport.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports